
import React from 'react';

import { Chip, useTheme } from '@/components/ui';
import { badgeStyles, getPriorityStyle } from '@/styles';

export const PriorityBadge: React.FC<{ priority: number | string }> = ({ priority }) => {
	const theme = useTheme();
	let label = 'Unknown';

	switch(priority) {
		case 0:
		case 'urgent':
			label = 'Urgent';
			priority = 0;
			break;
		case 1:
		case 'high':
			label = 'High';
			priority = 1;
			break;
		case 2:
		case 'medium':
			label = 'Medium';
			priority = 2;
			break;
		case 3:
		case 'low':
			label = 'Low';
			priority = 3;
			break;
		default:
			if (typeof priority === 'string') {
				label = priority;
			}
			break;
	}

	return (
		<Chip
			mode="flat"
			style={{
				...badgeStyles.badge,
				backgroundColor: getPriorityStyle(priority).backgroundColor,
			}}
			textStyle={{ color: theme.colors.surface }}
		>
			{label}
		</Chip>
	);
};
